module.exports = __webpack_public_path__ + "static/acura-ilx-white-front-grill-allstocksociety-600px-d45e8474e5a0b840114673cdf2599b9e.jpg";